import { useMutation } from "@tanstack/react-query";
import { updateCustomer, updateStatusCustomer, deleteCustomer, createCustomer, updateStatusListing } from "./api";

export const useUpdateCustomer = () => {
  return useMutation({
    mutationFn: ({ customerId, data }) => updateCustomer(customerId, data),
  });
};

export const useUpdateStatusCustomer = () => {
  return useMutation({
    mutationFn: ({ customerId, data }) => updateStatusCustomer(customerId, data),
  });
};

export const useDeleteCustomer = () => {
  return useMutation({
    mutationFn: ({ customerId }) => deleteCustomer(customerId),
  });
};

export const useCreateCustomer = () => {
  return useMutation({
    mutationFn: ({ data }) => createCustomer(data),
  });
};

export const useUpdateStatusListing = () => {
  return useMutation({
    mutationFn: ({ id, data }) => updateStatusListing(id, data),
  });
};